module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-collector-3.9c950791.svg";